import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {contactRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {ContactTypes} from "../../utils/constants";
import {useContactService} from "../../services/contact-service";

const AddEditContactModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [reset, setReset] = useState(0);

  let formSchema = contactRequestSchema;

  let contactService = useContactService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null, morphModel, morphId, type= ContactTypes.email.val) => {
    setLoading(true);
    if (!morphId || !morphModel){
      throw new Error('No morph info');
    }

    let promises = [
      Promise.resolve({contactable_type: morphModel, contactable_id: morphId})
    ];

    if (model && model.id){
      promises.push(getDetail(model.id));
    }

    Promise.all(promises).then(([morphData={}, detail= {}])=>{
      let newDetail = Object.assign({}, {type: type}, detail, morphData);
      setModel(formSchema.cast(newDetail));
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return contactService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};

    contactService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue}) => (

          <Modal size="lg" show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nový kontakt' : 'Úprava kontaktu' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form className="row">
                  <FormGroup
                    name="type"
                    type="select"
                    options={Object.values(ContactTypes)}
                    optionLabel="title"
                    optionKey="val"
                    placeholder="typ"
                    label="Typ"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="contact"
                    placeholder={model?.type===ContactTypes.email.val ? 'nieco@nieco.sk' : '+421903 111 222'}
                    label="Kontakt"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="title"
                    placeholder={'Názov'}
                    label="Názov"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditContactModal;
